import lodash from "lodash"

import { createAtomFamily } from "utils/recoil"
import testtree from "./testtree.json"
import { parseTree } from "./utils"

const prefix = "containers/Tariffs"

export const treeStateFamily = createAtomFamily({
  prefix,
  key: "tree"
  // default: { ...parseTree(testtree) }
})
